// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3dAUV","footer":"ModalInfo_footer__3Kshd"};